import styled from "styled-components";
import Colors from "infrastructure/utils/colors";

export const HeaderPill = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-shrink: 0;
  min-height: 48px;
  box-sizing: border-box;
  background: ${Colors.white};
  border-radius: 14px;
  padding: 0 12px;
  border: 1px solid ${Colors.border};
  box-shadow: 0 1px 3px ${Colors.shadow};
`;

export const UserMenuTrigger = styled.button`
  display: inline-flex;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font: inherit;
  color: inherit;

  &:focus-visible {
    outline: 2px solid ${Colors.dark_mint};
    outline-offset: 2px;
    border-radius: 14px;
  }
`;

export const AdminName = styled.span`
  color: ${Colors.charcoal_grey};
  font-family: Famtree;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.25;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LogoutMenuItem = styled.span`
  display: inline-flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 8px;
  font-family: Famtree;
  font-size: 14px;
  color: ${Colors.charcoal_grey};
`;
